/* eslint func-names: 0 */

import React from 'react';
import FullscreenMixin from '@jimpick/react-fullscreen-component';

const FullScreen = React.createClass({
  propTypes: {
    children: React.PropTypes.node,
    style: React.PropTypes.object
  },
  mixins: [FullscreenMixin],
  componentDidMount: function () {
    try {
      this.requestFullscreen(document.body);
    } catch (error) {
      // console.log('RequestFullscreen', error);
    }
  },
  render: function () {
    return (
      <div style={this.props.style} ref="container">
        {this.props.children}
      </div>
    );
  }
});

export default FullScreen;



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/src/fullscreen.jsx